import {
  FieldProps,
  RadioGroupProps as InformedRadioGroupProps,
  useField,
} from 'informed';
import { useMemo } from 'react';
import RadioGroupContext from '@tymbe/components/inputs/radio/RadioGroupContext';
import { TyInputError } from '../InputError';
import classNames from 'classnames';

type OwnProps = Omit<InformedRadioGroupProps, 'options'>;

export const TyRadioGroup = (
  props: FieldProps<OwnProps, string | undefined, Record<string, unknown>>
) => {
  const { fieldApi, fieldState, userProps } = useField(props);
  const {
    id,
    children,
    className
  } = userProps;
  const { showError, error } = fieldState;

  const groupContext = useMemo(
    () => ({
      radioGroupApi: fieldApi,
      radioGroupState: fieldState,
      required: true,
      ...props,
      id,
    }),
    [fieldApi, fieldState, id, props]
  );

  return (
    <RadioGroupContext.Provider value={groupContext}>
      <fieldset
        aria-describedby={`${id}-error`}
        className={classNames(
          className,
          !!(showError && error) && 'border-special-outline-error'
        )}
      >
        <>
          {showError && error ? (
            <legend>
              <TyInputError name={props.name} />
            </legend>
          ) : null}
          {children}
        </>
      </fieldset>
    </RadioGroupContext.Provider>
  );
};
